import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'

function WonderKidListTemplate({post, postsFB}) {

    const [isAdded, setIsAdded] = useState(false)
    const [fbId, setFbId] = useState()
    const [message, setMessage] = useState("")

    useEffect(() => {

       if (isAddedToFB(post, postsFB)) {
           setIsAdded(true)
           const firebaseId = getFbId(post, postsFB)
           setFbId(firebaseId)
       }

    }, [post, postsFB])

    function getFbId(wonderkid, allWonderkids) {
        let firebaseId
        const filteredList = allWonderkids.filter(player => player.wp_id === wonderkid.id)
        if (filteredList?.length > 0) {
            firebaseId = filteredList[0].id
        }
        return firebaseId
    }

    function isAddedToFB(wonderkid, allWonderkids) {
        let isAddedToList = false 
        const filteredList = allWonderkids.filter(player => player.wp_id === wonderkid.id)
        if (filteredList?.length > 0) {
            isAddedToList = true
        }
        return isAddedToList
    }

    async function addWonderKidHandler() {
        try {
            const wonderKidsRef = firestore.collection("wonderkids");
            const data = {
                wp_content: post,
                date: new Date().toISOString(),
                title: post?.title?.rendered,
                wp_id: post.id
            }
            wonderKidsRef.add(data)
            setMessage("Added")
        } catch (error) {
            
        }
    }

    async function updateWonderKidHandler(firebaseId) {
        if (!firebaseId) {
            console.log("No firebaseId", firebaseId)
            return 
        }
        try {
            const wonderKidsRef = firestore.collection("wonderkids").doc(firebaseId)
            const data = {
                wp_content: post,
                date_updated: new Date().toISOString(),
                title: post?.title?.rendered,
                wp_id: post.id
            }
            wonderKidsRef.update(data)
            setMessage("Updated")
            console.log("Updated")
        } catch (error) {
            console.log("ERROR UPDATE")
        }
    }

    return (
        <div>
            <p>{post?.title?.rendered} 
                <span className="float-right">
                    {isAdded ? 
                        <button onClick={() => updateWonderKidHandler(fbId)}><i className="fas fa-check"></i></button> 
                    :
                        <button onClick={addWonderKidHandler}><i className="fas fa-plus"></i></button>
                    }
                </span>
            </p>
        </div>
    )
}
export default WonderKidListTemplate